<template>
  <div class="newStudentFace">
    <el-row style="margin-top: 50px;">
        <p style="color: #C0C4CC;">请开始人脸识别！</p>
        <el-button type="primary" v-if="!distinguish_show" @click="getCompetence">开始识别</el-button>
    </el-row>
    <el-row v-show="distinguish_show"  style="width: 500px;margin: 0 auto;background-color: #ffffff;margin-top:-50px;">
        <el-row style="text-align: center;margin-top: 10px;">
          <el-row style="text-align: center;padding: 10px;color: #409eff;">{{tips}}</el-row>
          <!-- <el-progress :percentage="percentage" status="success" :color="customColors"></el-progress> -->
          <video id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay></video>
          <canvas style="display:none;" id="canvasCamera" :width="videoWidth" :height="videoHeight" ></canvas>
        </el-row>
        <el-row style="text-align: center;">
          <el-button type="primary" @click="stopNavigator" style="margin-bottom: 10px;">取消识别</el-button>
        </el-row>
    </el-row>
    </div>
  </div>
</template>

<script>
import rzImg from '@/images/user/rz.png';
import * as faceapi from "face-api.js";
export default {
  name: "newStudentFace",
  props: {
    verificationTimes: { //验证次数
      type: Number,
      default: 10
    },
  },
  data() {
    return {
      tag:1,
      tips:"人脸识别中...",
      rzImg:rzImg,
      distinguish_show: false,
      videoWidth: 400,
      videoHeight: 300,
      imgSrc: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      setTimeoutInfo:null,
      faceNumber:0 //控制人脸识别次数
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    getCompetence () { //开始人脸识别
        this.faceNumber = 0;
        this.distinguish_show = true;
        var _this = this;
        this.thisCancas = document.getElementById('canvasCamera')
        this.thisContext = this.thisCancas.getContext('2d')
        this.thisVideo = document.getElementById('videoCamera')
        // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
        if (navigator.mediaDevices === undefined) {
            navigator.mediaDevices = {}
        }
        // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
        // 使用getUserMedia，因为它会覆盖现有的属性。
        // 这里，如果缺少getUserMedia属性，就添加它。
        if (navigator.mediaDevices.getUserMedia === undefined) {
            navigator.mediaDevices.getUserMedia = function (constraints) {
              // 首先获取现存的getUserMedia(如果存在)
              var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
              // 有些浏览器不支持，会返回错误信息
              // 保持接口一致
              if (!getUserMedia) {
                return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
              }
              // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
              return new Promise(function (resolve, reject) {
                getUserMedia.call(navigator, constraints, resolve, reject)
              });
            }
          }
          var constraints = { audio: false, video: { width: this.videoWidth, height: this.videoHeight, transform: 'scaleX(-1)' } }
          navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
            // 旧的浏览器可能没有srcObject
            if ('srcObject' in _this.thisVideo) {
              _this.thisVideo.srcObject = stream
            } else {
              // 避免在新的浏览器中使用它，因为它正在被弃用。
              _this.thisVideo.src = window.URL.createObjectURL(stream)
            }
            _this.thisVideo.onloadedmetadata = function (e) {
              _this.thisVideo.play();
              setTimeout(()=>{
                _this.setImage();
              },500);
            }
          }).catch(err => {
            console.log(err)
          });
    },
    //  绘制图片（拍照功能）
    setImage () {
      var _this = this
      // 点击，canvas画图
      _this.thisContext.drawImage(_this.thisVideo, 0, 0, _this.videoWidth, _this.videoHeight)
      // 获取图片base64链接
      var image = this.thisCancas.toDataURL('image/png')
      _this.imgSrc = image;
      this.getFace(); //调用人脸识别接口对比
    },
    // base64转文件
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    // 关闭摄像头 取消人脸识别
    stopNavigator () {
        this.clearTime();
        this.distinguish_show = false;
        if(this.thisVideo != null){
            this.thisVideo.srcObject.getTracks()[0].stop();
        }
        if(!this.$isEmpty(this.setTimeoutInfo)){
            clearTimeout(this.setTimeoutInfo);
        }
    },
    getFace(){ // 百度人脸识别接口
        this.$store.dispatch("user/studentNewFace",{image:this.imgSrc}).then((ret) => {
          if (ret.code == 0) {
            this.thisVideo.srcObject.getTracks()[0].stop();
            this.distinguish_show = false;
            this.$message({
                message: "人脸识别成功！",
                type: 'success',
                duration:1500,
                onClose: () => {
                    this.$emit("successFace");
                }
            });
          } else {
              this.faceNumber ++;
              if(this.faceNumber >= 6){ //连续人脸识别6次都失败则退出人脸识别
                this.stopNavigator();
                return;
              }
              this.$message({message: ret.msg,type: 'warning'});
              this.setTimeoutInfo = setTimeout(()=>{
                  this.setImage();
              },5000);
          }
        })
    },
    clearTime(){
        if(!this.$isEmpty(this.setTimeoutInfo)){
            clearTimeout(this.setTimeoutInfo);
        }
    }
  },
  beforeDestroy() {
    this.clearTime();
    this.stopNavigator();
  },
};
</script>

<style scoped>
.newStudentFace{
  .see {
    position: relative;
  }
  .see canvas {
    position: absolute;
    top: 0;
    left: 0;
  }
  .option {
    padding-bottom: 20px;
  }
  .option div {
    padding: 10px;
    border-bottom: 2px #42b983 solid;
  }
  .option div label {
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newStudentFace.vue